var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isEmptyItems
    ? _c(
        "div",
        { staticClass: "ds-control ds-custom-drop-tree_empty" },
        [
          _vm._t("emptyItems", function () {
            return [_vm._v(" 请双击或拖拽相关字段到此处 ")]
          }),
        ],
        2
      )
    : _c(
        "div",
        { staticClass: "ds-control ds-custom-drop-tree" },
        [
          _c("DsfCustomDropTreeLogicNode", {
            attrs: { data: _vm.data },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (ref) {
                    var data = ref.data
                    return [_vm._t("item", null, { item: data })]
                  },
                },
              ],
              null,
              true
            ),
          }),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }